import { render } from "./upsertDraftDetailDialog.vue?vue&type=template&id=105211f0"
import script from "./upsertDraftDetailDialog.vue?vue&type=script&lang=js"
export * from "./upsertDraftDetailDialog.vue?vue&type=script&lang=js"

import "./upsertDraftDetailDialog.vue?vue&type=style&index=0&id=105211f0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__